import { Radio } from '@linktivity/link-ui';

import type { SeatPreferenceOption } from '../../types';

import styles from './seatPreferenceSelector.module.css';

export interface SeatPreferenceSelectorProps<
  T extends SeatPreferenceOption = SeatPreferenceOption
> {
  title?: string;
  options: readonly T[];
  value?: string;
  disabled?: boolean;
  onChange: (option: T) => void;
}

const SeatPreferenceSelector = <T extends SeatPreferenceOption>({
  title,
  options,
  value,
  disabled = false,
  onChange
}: SeatPreferenceSelectorProps<T>) => (
  <section>
    {title && <h2 className={styles.title}>{title}</h2>}
    <Radio.Group
      className={styles.options}
      value={value}
      disabled={disabled}
      onChange={code => {
        const option = options.find(item => item.code === code);
        if (option) {
          onChange(option);
        }
      }}
    >
      {options.map(option => (
        <Radio
          key={option.code}
          className={styles.option}
          value={option.code}
          label={option.name}
        />
      ))}
    </Radio.Group>
  </section>
);

export default SeatPreferenceSelector;
